import { useRecoilValue } from 'recoil';
import { useAuth } from 'services/auth/hooks';
import { userAtom } from 'services/user/atoms';

export const useNavBarOptions = () => {
  const { userAuth } = useAuth();
  const user = useRecoilValue(userAtom);

  const isAuthenticatedAndOnboard = !!userAuth?.username && !!user?.isOnboard;

  return {
    isAuthenticatedAndOnboard
  };
};
